<app-header [label]="pageTitle"></app-header>

<div class="min-h-screen font-sans text-gray-600 flex flex-col gap-4 w-full p-4">
  <div class="bg-white rounded-xl border border-gray-200 p-6">
    <form [formGroup]="form">
      <div class="py-2 grid grid-cols-1 lg:grid-cols-[240px_1fr] gap-2 lg:gap-x-2">
        <div class="flex flex-col items-start">
          <app-file-uploader formControlName="image" lebal="IMAGE" accept=".jpg,.jpeg,.png" uploaderVariant="photo-box" photoBoxSize="lg"></app-file-uploader>
        </div>
        <div class="min-w-0 grid grid-cols-1 md:grid-cols-2 gap-4">
          <app-text-input class="w-full md:col-span-2" type="text" [is_required]="true" [label]="'Name'" formControlName="name"></app-text-input>
          <app-text-input class="w-full" type="number" [is_required]="true" [label]="'Contact'" formControlName="contact"></app-text-input>
          <app-text-input class="w-full" [is_required]="true" [label]="'Email'" formControlName="email"></app-text-input>
          <div>
            <ng-container *ngIf="showPasswordField">
              <app-text-input [mask]="true" type="password" [is_required]="true" class="w-full" [label]="'Password'" formControlName="password"></app-text-input>
            </ng-container>
            <div *ngIf="form.get('password')?.invalid && (form.get('password')?.dirty || form.get('password')?.touched)">
              <small class="text-red-500" *ngIf="form.get('password')?.errors?.['pattern']">
                (Min 8 chars, 1 Uppercase, 1 Number, 1 Special Char)
              </small>
            </div>
          </div>
          <div class="md:col-span-2">
            <div class="h-px bg-gray-200"></div>
          </div>
          <app-select-input label="Role" class="w-full" [is_required]="true" formControlName="role_id" [options]="ds.dropdown_list?.role_list"></app-select-input>
          <app-select-input label="School" *ngIf="selectedRole?.belongs_to !== 'all'" class="w-full md:col-span-2" [is_required]="true" formControlName="university_id" [options]="ds.dropdown_list?.university_list"></app-select-input>
          <app-select-input *ngIf="selectedRole?.belongs_to === 'college'" label="School Branch" class="w-full md:col-span-2" [is_required]="true" formControlName="college_id" [options]="ds.dropdown_list?.college_list | filterByKeyAndValue : 'university_id' :form.get('university_id')?.value"></app-select-input>
          <app-select-input *ngIf="selectedRole?.belongs_to === 'subject'" label="Subject" [is_multiple]="true" class="w-full md:col-span-2" [is_required]="true" formControlName="subject_ids" [options]="ds.dropdown_list?.subject_list | filterByKeyAndValue : 'university_id' : form.get('university_id')?.value"></app-select-input>
        </div>
      </div>

      <div class="flex justify-between items-center gap-2 mt-4">
        <div>
          <app-button *ngIf="!isViewMode && selected_ids?.id && !showPasswordField" color="border-primary text-primary" label="Reset Paasowrd" type="button" (click)="resetPassword()"></app-button>
          <!-- <app-button *ngIf="!isViewMode && selected_ids?.id && showPasswordField" color="border-gray-400 text-gray-700" label="Hide Password" type="button" (click)="hidePassword()"></app-button> -->
        </div>
        <div class="flex justify-end items-center gap-2">
          <app-button color="border-primary text-primary" [label]="isViewMode ? 'Back' : 'Cancel'" type="button" (click)="cancel()"></app-button>
          <app-button *ngIf="!isViewMode" color="bg-secondary text-black" [label]="selected_ids?.id ? 'Update' : 'Add'" type="button" [disabled]="isSubmitting" [submit]="submit.bind(this)"></app-button>
        </div>
      </div>
    </form>
  </div>
</div>